import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { RootLayoutComponent } from './components/root-layout/root-layout.component';
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  BACKEND_DATE_FORMAT_TOKEN,
  BACKEND_DATETIME_FORMAT_TOKEN,
  BACKEND_TIME_FORMAT_TOKEN,
  FRONTEND_DATE_FORMAT_OPTIONS_TOKEN,
  FRONTEND_DATETIME_FORMAT_OPTIONS_TOKEN,
  FRONTEND_TIME_FORMAT_OPTIONS_TOKEN,
} from '@airnauts/ng-components';
import {
  BACKEND_DATE_FORMAT,
  BACKEND_DATETIME_FORMAT,
  BACKEND_TIME_FORMAT,
  FRONTEND_DATE_FORMAT_OPTIONS,
  FRONTEND_DATETIME_FORMAT_OPTIONS,
  FRONTEND_TIME_FORMAT_OPTIONS,
} from '@/utils/constants';
import { NavbarComponent } from './components/navbar/navbar.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { SectionModule } from "@/shared/components/section/section.module";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSnackBarModule } from "@angular/material/snack-bar";

const MATERIAL_MODULES = [
  MatDialogModule,
];

@NgModule({
  declarations: [
    SidebarComponent,
    RootLayoutComponent,
    NavbarComponent,
  ],
  exports: [
    RootLayoutComponent,
    MATERIAL_MODULES,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    SectionModule,
    MatSidenavModule,
    MatIconModule,
    MatSnackBarModule,
    MATERIAL_MODULES,
  ],
  providers: [
    {
      provide: BACKEND_TIME_FORMAT_TOKEN,
      useValue: BACKEND_TIME_FORMAT,
    },
    {
      provide: BACKEND_DATE_FORMAT_TOKEN,
      useValue: BACKEND_DATE_FORMAT,
    },
    {
      provide: BACKEND_DATETIME_FORMAT_TOKEN,
      useValue: BACKEND_DATETIME_FORMAT,
    },
    {
      provide: FRONTEND_TIME_FORMAT_OPTIONS_TOKEN,
      useValue: FRONTEND_TIME_FORMAT_OPTIONS,
    },
    {
      provide: FRONTEND_DATE_FORMAT_OPTIONS_TOKEN,
      useValue: FRONTEND_DATE_FORMAT_OPTIONS,
    },
    {
      provide: FRONTEND_DATETIME_FORMAT_OPTIONS_TOKEN,
      useValue: FRONTEND_DATETIME_FORMAT_OPTIONS,
    },
  ],
})
export class CoreModule { }
